import React from "react";

function ComponentHeader({ title, filter, descript, handleClick }) {
  return (
    <div className="px-3 d-flex justify-content-between align-items-center mt-4">
      <p className="fw-semibold headFont" >
        {title}
      </p>
      <p className="d-flex align-items-center gap-2">
        <span
          className="fw-bold pointer headFont"
          style={{
            color:
              descript === "View All"
                ? "rgba(31, 126, 120, 1)"
                : "rgba(136, 136, 136, 1)",
            
          }}
          onClick={handleClick}
        >
          {descript}
        </span>{" "}
        {filter && (
          <div
            className={title === "Programs" ? "" : "btn p-0 m-0"}
            style={{ backgroundColor: "rgba(227, 236, 237, 1)" }}
          >
            {filter}
          </div>
        )}
      </p>
    </div>
  );
}

export default ComponentHeader;
